import { getReports } from '@/services';
import { type IQueryParams, type Report } from '@/types';
import { defineStore } from 'pinia';

type TabKey = 'fixed' | 'awaiting_fix' | 'fix_pending';

interface TabState {
  loading: boolean;
  data: Report[];
  paginationMetadata: Record<string, any>;
}

export const useReportsStore = defineStore('reports', {
  state: (): Record<TabKey, TabState> => ({
    fixed: {
      loading: false,
      data: [] as Report[],
      paginationMetadata: {
        total: 0,
        count: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0
      }
    },
    awaiting_fix: {
      loading: false,
      data: [] as Report[],
      paginationMetadata: {
        total: 0,
        count: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0
      }
    },
    fix_pending: {
      loading: false,
      data: [] as Report[],
      paginationMetadata: {
        total: 0,
        count: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0
      }
    }
  }),

  actions: {
    async fetchReportTab(tab: TabKey, query: IQueryParams) {
      try {
        this.$state[tab].loading = true;
        const { data } = await getReports(tab, query);
        if (data.value) {
          this.$state[tab].data = data.value.data;
          this.$state[tab].paginationMetadata = data.value.pagination;
        }
      } catch (err) {
        throw new Error('Error fetching tab data');
      } finally {
        this.$state[tab].loading = false;
      }
    },
    $reset(tab: TabKey) {},
    resetData(tab: TabKey) {}
  }
});
